import {
  PATIENT_PORTAL_SYSTEM_IDS,
  PatientPortalSystemOptions,
} from 'types/patient-portal-system.types';

import CommonEn from 'locales/common/en.json';
import AmplarEn from 'locales/amplar/en.json';
import MyHealthEn from 'locales/myhealth/en.json';

export type TenantLocales = {
  default: Record<string, string>;
  en: Record<string, string>;
};

function mergeLocale(
  common: Record<string, string>,
  tenant: Record<string, string>,
): Record<string, string> {
  return { ...common, ...tenant };
}

export const tenantLocales: Record<PatientPortalSystemOptions, TenantLocales> =
  {
    [PATIENT_PORTAL_SYSTEM_IDS.AMPLAR]: {
      default: mergeLocale(CommonEn, AmplarEn),
      en: mergeLocale(CommonEn, AmplarEn),
    },
    [PATIENT_PORTAL_SYSTEM_IDS.MY_HEALTH]: {
      default: mergeLocale(CommonEn, MyHealthEn),
      en: mergeLocale(CommonEn, MyHealthEn),
    },
  };
